// extracted by mini-css-extract-plugin
module.exports = {"AddProductPage":"AddProductPage_AddProductPage__3eXLe","Icon":"AddProductPage_Icon__3aipV","Span":"AddProductPage_Span__2EYF6","Price":"AddProductPage_Price__2pZiP"};